/**
 * ----------------------------------------------------------------------------------------------
 * individual JS for Cart Page
 * ----------------------------------------------------------------------------------------------
 */

const manageCheckoutBtn = (e) => {
  // 2024.4.11 : チェックアウト確認用のポップアップ+チェックアウトボタンに制御対象を変更
  // const checkout_btn = document.querySelector('[name="checkout"]');
  const checkoutButtonList = document.querySelectorAll('#checkout-confirm-btn,[name="checkout"]');
  const agreementCheckList = document.querySelectorAll("[data-agreement_checkbox]");
  let agreeFlg = true
  agreementCheckList.forEach((checkbox) => {
    if (checkbox.checked === false) {
      agreeFlg = false;
    }
  });
  if (agreeFlg === true) {
    // checkout_btn.removeAttribute("disabled");
    checkoutButtonList.forEach((checkoutBtn) => { 
      checkoutBtn.removeAttribute("disabled");
    });
  } else {
    // checkout_btn.setAttribute("disabled", true);
    checkoutButtonList.forEach((checkoutBtn) => { 
      checkoutBtn.setAttribute("disabled", true);
    });
  }
};

window.addEventListener("pageshow", () => {
  const agreementCheckbox = document.getElementById("agreement");
  if (agreementCheckbox) agreementCheckbox.checked = false;
});


// CartAttributes更新
// _field: Attribute更新のフィールド
const updateOrderAttribute = (_field,_value) =>{
  const form_data = {
    attributes: {}
  }
  form_data.attributes[_field] = _value;
  fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'dataType': 'json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(form_data)
    })
    .then((data) => {
      console.log(`${_field} updated. ${form_data.attributes[_field]}`)
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

// 各オプションのツールチップを表示
const dipsTooltip = (obj)=>{
  if(obj.getAttribute('area-expand') === "true"){
    obj.setAttribute('area-expand',"false");
    document.querySelector('.c-option-tooltip').remove();
    document.querySelector('.c-option-tooltip__background').remove();
    document.body.classList.remove("is-fixed-scroll");
  }else{
    obj.setAttribute('area-expand',"true");
    const tooltipId = obj.getAttribute("data-tooltip_id");
    const tooltipInnerHTML = document.getElementById(tooltipId).innerHTML;
    obj.insertAdjacentHTML('afterend',`
    <div class="c-option-tooltip">
      ${tooltipInnerHTML}
    </div>
    <div class="c-option-tooltip__background" onclick="closeToolTip()"></div>
    `);
    document.body.classList.add("is-fixed-scroll");
  }
}
const closeToolTip = () => {
  const openingTooltipBtn = document.querySelector('.c-option-tooltip__toggle[area-expand="true"]');
  openingTooltipBtn.setAttribute('area-expand',"false");
  document.querySelector('.c-option-tooltip').remove();
  document.querySelector('.c-option-tooltip__background').remove();
  document.body.classList.remove("is-fixed-scroll");
}

// 2024.7.20 Add カート備考欄の初期化処理
// カートページ表示時、備考欄テキストがない場合は備考欄を初期化する
window.addEventListener('load', async () => {
  const noteInput = document.querySelector("#cart-note-area");

  if(!noteInput){
    const cartContent = await (await fetch(`${window.routes.cartUrl }.js`, {cache: 'reload'})).json();

    if(cartContent?.note.length > 0){
      fetch("".concat(window.routes.cartUrl, "/update.js"), {
        body: JSON.stringify({
          note: ""
        }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'

        }
      });
    }
  }
});